module.exports = __webpack_public_path__ + "img/3.373bdbc1.png";